module.exports = __webpack_public_path__ + "img/sohba-3.f9e6e76.webp";